import {forwardRef, useCallback} from "react";

// --- Hooks ---
import {useTiptapEditor} from "components/RichEditor/hooks/use-tiptap-editor";

// --- UI ---
import {Button} from "components/RichEditor/components/tiptap-ui-primitive/button";
import {SelectTemplateIcon} from "components/RichEditor/components/tiptap-icons/select-template-icon";

export const SelectTemplateButton = forwardRef(
  ({editor: providedEditor, onClick, ...props}, ref) => {
    const {editor} = useTiptapEditor(providedEditor);

    const handleClick = useCallback(
      (e) => {
        onClick?.(e);
        if (e.defaultPrevented) return;

        editor?.chain().focus().run();
      },
      [editor, onClick]
    );

    if (!editor) return null;

    return (
      <Button
        type="button"
        variant="ghost"
        tooltip="RICH_EDITOR_TOOLBAR_SELECT_TEMPLATE_BUTTON_TOOLTIP"
        onClick={handleClick}
        ref={ref}
        {...props}
      >
        <SelectTemplateIcon width="18px" height="18px" />
      </Button>
    );
  }
);
